import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";
import CloseIcon from "@material-ui/icons/Close";
import { useSelector } from "react-redux";
import { customSelectStyle } from "../../../../_metronic/_partials/dropdowns/ReactSelectCustomStyle";

function CardBrandIcon({ brand }) {
  const paymentMethodsRelation = useSelector(
    state => state.app.payment_methods_relation || []
  );
  const paymentMethod = paymentMethodsRelation.find(
    relation => relation.id === brand?.toLowerCase()
  );

  if (!paymentMethod) return null;

  return (
    <img
      alt={brand}
      src={paymentMethod.svg}
      style={{ height: "23px", width: "auto" }}
    />
  );
}

function CardOptionLabel({ card }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <CardBrandIcon brand={card.brand} />
      <span>{`${card.brand} •••• ${card.last_digits} — Val: ${card.expiration_date}`}</span>
    </div>
  );
}

export default function ReactivationModal({
  show,
  onClose,
  onConfirm,
  onConfirmPix = () => {},
  serviceName,
  creditCards = [],
  isLoadingCards = false
}) {
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedMethod, setSelectedMethod] = useState('card');
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    if (!selectedCard) return;
    setIsLoading(true);
    try {
      await onConfirm(selectedCard);
    } catch (error) {
      console.error("Erro ao reativar serviço:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirmPix = async () => {
    setIsLoading(true);
    try {
      await onConfirmPix();
    } catch (error) {
      console.error("Erro ao reativar via PIX:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setSelectedCard(null);
    setSelectedMethod('card');
    setIsLoading(false);
    onClose();
  };

  const isConfirmDisabled = isLoading || (selectedMethod === 'card' && !selectedCard);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>Reativar {serviceName}</Modal.Title>
        <span
          onClick={handleClose}
          aria-label="Fechar"
          style={{
            position: "absolute",
            top: "12px",
            right: "16px",
            cursor: "pointer",
            color: "#6c757d",
            borderRadius: "50%",
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "background 0.2s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = "rgba(0,0,0,0.08)"}
          onMouseLeave={e => e.currentTarget.style.background = "none"}
        >
          <CloseIcon style={{ fontSize: "1.4rem" }} />
        </span>
      </Modal.Header>

      <Modal.Body>
        <p>Selecione a forma de pagamento utilizada para reativar o serviço.</p>

        <hr />

        {/* Seletor de método de pagamento */}
        <div className="btn-group w-100 mb-5" role="group">
          <button
            type="button"
            className={`btn ${selectedMethod === 'card' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => { setSelectedMethod('card'); setSelectedCard(null); }}
            style={{ width: "50%" }}
          >
            <i className="fas fa-credit-card mr-2" />
            Cartão de crédito
          </button>
          <button
            type="button"
            className={`btn ${selectedMethod === 'pix' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setSelectedMethod('pix')}
            style={{ width: "50%" }}
          >
            <i className="fas fa-bolt mr-2" />
            PIX
          </button>
        </div>

        {/* Seção de cartão de crédito */}
        {selectedMethod === 'card' && (
          <Form.Group>
            <Form.Label>Cartão de crédito</Form.Label>
            <Select
              name="card"
              options={creditCards}
              value={selectedCard}
              onChange={setSelectedCard}
              isLoading={isLoadingCards}
              placeholder="Selecione um cartão..."
              getOptionLabel={(card) => `${card.brand} •••• ${card.last_digits} — Val: ${card.expiration_date}`}
              formatOptionLabel={(card) => <CardOptionLabel card={card} />}
              getOptionValue={(card) => card.hash}
              noOptionsMessage={() => <span>Nenhum cartão cadastrado.</span>}
              theme={customSelectStyle}
              isClearable={false}
            />
          </Form.Group>
        )}

        {/* Seção PIX */}
        {selectedMethod === 'pix' && (
          <div className="alert alert-custom alert-light-warning alert-notice mb-0" role="alert">
            <div className="alert-icon">
              <i className="fas fa-info-circle text-warning"></i>
            </div>
            <div className="alert-text">
              Ao confirmar, você atesta que o cliente já realizou o pagamento via PIX. O serviço será reativado automaticamente.
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={selectedMethod === 'pix' ? handleConfirmPix : handleConfirm}
          disabled={isConfirmDisabled}
        >
          {isLoading ? "Reativando..." : "Confirmar Reativação"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

